import {
  navigationStyleApi,
  selectNavigationStyleApiData,
} from 'api/navigationStyle'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectApp } from 'selectors/app'
import { selectThemeId } from 'selectors/landingPageTheme'
import { selectOrderingEnabled } from 'selectors/merchant'
import { reset } from 'slices/Cms/Content/AppNavigation/Style'
import { setChanges } from 'slices/Cms/Content/AppNavigation/Style'
import { selectStyle } from 'slices/Cms/Content/AppNavigation/Style/selectors'
import { apiStateToSliceState, sliceStateToApiState } from './helpers'

export const useFetchNavigationStyle = () => {
  const app = useSelector(selectApp)
  const themeId = useSelector(selectThemeId)

  return navigationStyleApi.useGetNavigationStyleQuery(
    { appId: app?.id ?? 0, themeId: themeId ?? 0 },
    { skip: !app?.id || !themeId }
  )
}

// Ensure the UI is updated whenever the back-end API state changes (i.e. form submission)
export const useSyncApiState = () => {
  const dispatch = useDispatch()
  const orderingEnabled = useSelector(selectOrderingEnabled)
  const apiStyleState = useSelector(selectNavigationStyleApiData)

  useEffect(() => {
    const data = apiStateToSliceState(apiStyleState)
    if (data) {
      // If ordering is disabled, force placement to 'bottom'
      if (!orderingEnabled && data.placement === 'top') {
        dispatch(reset({ ...data, placement: 'bottom' }))
        dispatch(setChanges())
      } else {
        dispatch(reset(data))
      }
    }
  }, [apiStyleState, dispatch, orderingEnabled])
}

export const useSubmitNavigationStyle = () => {
  const app = useSelector(selectApp)
  const themeId = useSelector(selectThemeId)
  const styleState = useSelector(selectStyle)

  const [updateNavigationStyle] =
    navigationStyleApi.useUpdateNavigationStyleMutation()

  const submit = () => {
    if (!app?.id || !themeId) return Promise.resolve()

    const apiPayload = sliceStateToApiState(
      app.id,
      themeId,
      styleState.settings
    )
    return updateNavigationStyle(apiPayload).unwrap()

    // No need to manually update the reducer slice state,
    // the UI will automatically do this via the selectNavigationStyleApiData
  }

  return submit
}
